/**
 * index.ts - Skinnr - Theme and Skin Management System
 * 
 * CHANGE HISTORY:
 * - 251105_1516 [pending] danielbeer: Add Button and Slider components
 * - 251025_1728 danielbeer: Add Material UI integration exports
 * - 251021_2139 [819fb51] danielbeer: fix: Export registerDefaultSkins from skinnr main index and fix Producr import
 * - 251021_0421 [7529d5e] danielbeer: feat: migrate all packages to TypeScript structure
 */
import SkinnrManager from './SkinnrManager';
import { SkinnrProvider as Provider, useSkinnr as useSkinnrHook } from './SkinnrContext';

// Core Skinnr exports
export { default as Skinnr } from './SkinnrManager';
export { SkinnrProvider, useSkinnr } from './SkinnrContext';
export { registerDefaultSkins, defaultSkins } from './skins/index';

// UI Components
export { Button } from './components/Button';
export type { ButtonProps } from './components/Button';
export { Slider } from './components/Slider';
export type { SliderProps } from './components/Slider';
export { SkinnrCompactView } from './components/SkinnrCompactView';
export type { SkinnrCompactViewProps } from './components/SkinnrCompactView';

// Material UI integration exports
export { SkinnrMuiProvider, useSkinnrMui } from './SkinnrMuiProvider';
export { createSkinnrMuiTheme, updateMuiTheme } from './mui-theme';
export type { SkinnrThemeMode } from './mui-theme';

// CSS files are imported by consuming apps
// All styles:
//   import '@opcentral/skinnr/styles';
// 
// Or modular (tree-shakeable):
//   import '@opcentral/skinnr/styles/components/buttons.css';
//   import '@opcentral/skinnr/styles/components/navigation.css';
// 
// Variables only:
//   import '@opcentral/skinnr/variables';

export default {
  Skinnr: SkinnrManager,
  SkinnrProvider: Provider,
  useSkinnr: useSkinnrHook
};
